<template>
   <tr role="listitem">
      <td :class="className" class="cel-icon">
         <button
            :class="{active: favorite}"
            :aria-pressed="favorite"
            type="button"
            class="btn favorite"
            aria-label="Add to my favorites"
            @click="toggleFavorite()"
         ></button>
      </td>
      <td
         v-popover
         ref="tooltip"
         :title="career.jobDomain"
         :data-content="career.jobDomainDescription"
         class="form-check-label"
         data-container="body"
         data-trigger="hover"
         data-toggle="popover"
         data-placement="top"
      >
         <small>{{ career.jobDomain }}</small>
         <h2>{{ career.jobRole }}</h2>
      </td>
      <td>
         {{ career.trimCompetencies }}
      </td>
      <td>
         {{ career.jobLevel }}
      </td>
      <td>
         {{ career.minimumEducationRequirement }}
      </td>
   </tr>
</template>

<script>
import CareerObject from '@/components/CareerObject';

export default {
   name: 'CareerCard',
   extends: CareerObject,
};
</script>



// WEBPACK FOOTER //
// src/components/CareerListItem.vue